import { useDojoSettings } from '@/hooks/useDojoSettings';
import { useAuth } from '@/contexts/AuthContext';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { useTranslation } from 'react-i18next';

interface Props { title: string; description: string; activeTab?: string; onTabChange?: (tab: string) => void; }
export default function AdminDashboardHeader({ description }: Props) {
  const { settings } = useDojoSettings();
  const { profile, impersonation } = useAuth();
  const { t } = useTranslation('admin');
  const name = settings.dojo_name || impersonation.dojoName || 'WarriorHub';
  return <div className="wh-page-header wh-workspace-hero">
    <div className="flex min-w-0 items-center gap-4">
      <Avatar className="h-14 w-14 shrink-0 rounded-2xl border bg-card"><AvatarImage src={settings.dojo_logo_url || undefined} alt={name} className="object-contain p-1" /><AvatarFallback className="rounded-2xl bg-accent font-semibold text-accent-foreground">{name.slice(0,2).toUpperCase()}</AvatarFallback></Avatar>
      <div className="min-w-0"><p className="wh-eyebrow mb-1">{t("admin:studio.workspace", { defaultValue: 'Dojo workspace' })}</p><h1 className="wh-page-title break-words">{name}</h1><p className="mt-1 max-w-xl text-sm text-muted-foreground">{t("admin:studio.welcome", { defaultValue: 'Welcome back, {{name}}. Your dojo, at a glance.', name: profile?.first_name || '' })}</p></div>
    </div>
    <span className="wh-role-chip">{t("admin:studio.admin", { defaultValue: 'Administrator' })}</span>
  </div>;
}
